import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, viewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService } from '@prekog/common-ui';
import { Examination } from '../examination';
import { GetSpecialityRequest } from '../getspecialityrequest';
import { GetSpecialityResponse } from '../getspecialityresponse';
import { AddExaminationRequest } from './addexaminationrequest';

@Component({
    selector: 'app-addexamination',
    templateUrl: './addexamination.component.html',
    styleUrls: ['./addexamination.component.scss'],
    standalone: true,
    imports: [MatIconModule, ReactiveFormsModule, CommonModule, RouterModule, FormsModule]
})
export class AddexaminationComponent implements OnInit {
    addExaminationUrl = '/admin/add-examination';

    examination: Examination = {};

    examinationForm?: FormGroup;

    getSpecialityByIdUrl = '/regenero/get-speciality-by-routerLink';

    maxPrice: number | null = null;

    readonly maxPriceInput = viewChild<ElementRef>('maxPriceInput');

    minPrice: number | null = null;

    readonly minPriceInput = viewChild<ElementRef>('minPriceInput');

    price: number | null = null;

    readonly priceInput = viewChild<ElementRef>('priceInput');

    regeneroBaseUrl = '';

    routerLink = '';
    showMinMaxPrice = false;

    specialityId = 0;

    specialityName = '';

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _fb: FormBuilder
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            const lastSegmentOfUrl = window.location.href.split('/').pop();
            this.routerLink = lastSegmentOfUrl as string;
            this.getSpecialityByRouterLink();
            this.createExaminationForm();
        }
    }

    addExamination(): void {
        this.collectExaminationData();
        const addExaminationRequest: AddExaminationRequest = {
            examination: this.examination
        };

        this._apiRequestService
            .sendRequest<
                AddExaminationRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, addExaminationRequest, true, this.addExaminationUrl, true)
            .subscribe();
    }

    createExaminationForm(): void {
        this.examinationForm = this._fb.group({
            name: ['', [Validators.required]]
        });
    }

    collectExaminationData(): void {
        this.examination = {
            name: this.examinationForm?.controls['name'].value as string | undefined,
            price: this.price!,
            minPrice: this.minPrice!,
            maxPrice: this.maxPrice!,
            specialityId: this.specialityId
        };
    }

    getSpecialityByRouterLink(): void {
        const getspecialitybyidRequest: GetSpecialityRequest = {
            routerLink: this.routerLink
        };
        this._apiRequestService
            .sendRequest<
                GetSpecialityRequest,
                GetSpecialityResponse
            >(this.regeneroBaseUrl, getspecialitybyidRequest, true, this.getSpecialityByIdUrl)
            .subscribe((response) => {
                this.specialityName = response.speciality?.name as string;
                this.specialityId = response.speciality?.id as number;
            });
    }

    onChangePrice(): void {
        this.price = this.priceInput()?.nativeElement.value as number;
    }

    onChangeMinPrice(): void {
        this.minPrice = this.minPriceInput()?.nativeElement.value as number;
    }

    onChangeMaxPrice(): void {
        this.maxPrice = this.maxPriceInput()?.nativeElement.value as number;
    }

    showMaxMinPrices(): void {
        this.showMinMaxPrice = !this.showMinMaxPrice;
        this.price = null;
    }

    showPrice(): void {
        this.showMinMaxPrice = !this.showMinMaxPrice;
        this.minPrice = null;
        this.maxPrice = null;
    }
}
